import { Api } from "../../Api";
import { AccessLevel, Gender, Localization } from "./IUser";
import { UsersService } from "./UsersService";
export class User {
    constructor() {
        this._guid = "";
        this._cloudGuid = "";
        this._name = "";
        this._surname = "";
        this._phone = "";
        this._email = "";
        this._isAccountOnline = true;
        this._isAccountActive = true;
        this._isAccountBanned = true;
        this._notificationChannels = [];
        this._gender = Gender.Unknown;
        this._accessLevel = AccessLevel.Any;
        this._localization = Localization.En_Us;
        this._softwareVersion = "";
    }
    get Guid() {
        return this._guid;
    }
    set Guid(value) {
        this._guid = value;
    }
    get CloudGuid() {
        return this._cloudGuid;
    }
    set CloudGuid(value) {
        this._cloudGuid = value;
    }
    get Name() {
        return this._name;
    }
    set Name(value) {
        this._name = value;
    }
    get Surname() {
        return this._surname;
    }
    set Surname(value) {
        this._surname = value;
    }
    get Phone() {
        return this._phone;
    }
    set Phone(value) {
        this._phone = value;
    }
    get AccessLevel() {
        return this._accessLevel;
    }
    set AccessLevel(value) {
        this._accessLevel = value;
    }
    get Email() {
        return this._email;
    }
    set Email(value) {
        this._email = value;
    }
    get IsAccountOnline() {
        return this._isAccountOnline;
    }
    set IsAccountOnline(value) {
        this._isAccountOnline = value;
    }
    get IsActive() {
        return this._isAccountActive;
    }
    set IsActive(value) {
        this._isAccountActive = value;
    }
    get IsBanned() {
        return this._isAccountBanned;
    }
    set IsBanned(value) {
        this._isAccountBanned = value;
    }
    get NotificationChannels() {
        return this._notificationChannels;
    }
    set NotificationChannels(value) {
        this._notificationChannels = value;
    }
    get Gender() {
        return this._gender;
    }
    set Gender(value) {
        this._gender = value;
    }
    get Localization() {
        return this._localization;
    }
    set Localization(value) {
        this._localization = value;
    }
    get SoftwareVersion() {
        return this._softwareVersion;
    }
    set SoftwareVersion(value) {
        this._softwareVersion = value;
    }
    GetUserProfilePictureAsync() {
        return Api.Get(UsersService.ServiceName).GetUserProfilePictureAsync({ Guid: this._guid });
    }
    SetUserProfilePictureAsync(base64PictureString) {
        return Api.Get(UsersService.ServiceName).SetUserProfilePictureAsync({ Guid: this._guid }, base64PictureString);
    }
}
//# sourceMappingURL=User.js.map